import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'
import { useNavigate } from 'react-router-dom'

import { lossFactorsClient } from '@/api'
import { config } from '@/config'

const BASE_ROUTE = config.links.library.lossFactors
const BASE_QUERY_KEY = lossFactorsClient.QUERY_KEY

export const useLossFactors = () => {
  const { showSuccess } = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const lossFactorsQuery = useQuery({
    queryKey: [...BASE_QUERY_KEY, { lockedOnly: false }],
    queryFn: () => lossFactorsClient.getAll()
  })

  const addDatasetMutation = useMutation({
    mutationFn: lossFactorsClient.addDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully added')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const cloneDatasetMutation = useMutation({
    mutationFn: lossFactorsClient.cloneDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully cloned')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const removeDatasetMutation = useMutation({
    mutationFn: lossFactorsClient.removeDataset,
    onSuccess: async () => {
      showSuccess('Dataset successfully removed')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  return {
    lossFactorsDatasets: lossFactorsQuery.data || [],
    isFetching: lossFactorsQuery.isFetching && !lossFactorsQuery.isRefetching,
    addDataset: addDatasetMutation.mutate,
    isAddDatasetInProgress: addDatasetMutation.isPending,
    cloneDataset: cloneDatasetMutation.mutate,
    isCloneDatasetInProgress: cloneDatasetMutation.isPending,
    removeDataset: removeDatasetMutation.mutate
  }
}
